// FeesStructurePDF.jsx
import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

// ================= STYLES =================
const styles = StyleSheet.create({
  page: {
    padding: 8,
    fontSize: 6,
    fontFamily: "Helvetica",
  },

  // ===== HEADER =====
  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 3,
  },
  logoContainer: {
    width: "8%",
    alignItems: "flex-start",
  },
  textContainer: {
    width: "80%",
    alignItems: "center",
  },
  logo: {
    width: 30,
    height: 30,
  },
  title: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
  },
  subtitle: {
    fontSize: 8,
    fontWeight: "bold",
    marginTop: 1,
    textAlign: "center",
  },

  // ===== TABLE =====
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 1,
  },
  row: {
    flexDirection: "row",
  },
  thIndex: {
    width: "4%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 1,
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
    fontSize: 7,
  },
  th: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 1,
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
    fontSize: 7,
  },
  tdIndex: {
    width: "4%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 1,
    textAlign: "center",
    fontSize: 7,
  },
  td: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 1,
    textAlign: "center",
    fontSize: 7,
  },

  // ===== DESCRIPTION ROW =====
  descriptionRow: {
    backgroundColor: "#eeeeee",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
    fontSize: 7,
    fontWeight: "bold",
  },
});

// ================= COMPONENT =================
const FeesStructurePdf12 = ({ tableData = [] }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>
      {/* ===== HEADER ===== */}
      <View style={styles.header}>
        {/* Logo Left */}
        <View style={styles.logoContainer}>
          <Image src="/assets/images/jac.png" style={styles.logo} />
        </View>

        {/* Title + Subtitle Center */}
        <View style={styles.textContainer}>
          <Text style={styles.title}>JHARKHAND ACADEMIC COUNCIL, RANCHI</Text>
          <Text style={styles.subtitle}>
            Class XII - Fees Structure 2026 (Annual)
          </Text>
        </View>
      </View>

      {/* ===== TABLE ===== */}
      <View style={styles.table}>
        {/* Table Head */}
        <View style={styles.row}>
          <Text style={styles.thIndex}>#</Text>
          <Text style={styles.th}>Appearing</Text>
          <Text style={styles.th}>Caste Cate.</Text>
          <Text style={styles.th}>Reg. Yr.</Text>
          <Text style={styles.th}>Category</Text>
          <Text style={styles.th}>Gender</Text>
          <Text style={styles.th}>ODPPM Fee</Text>
          <Text style={styles.th}>Exam Fee</Text>
          <Text style={styles.th}>PC Fee</Text>
          <Text style={styles.th}>M/S F.C.T Fee</Text>
          <Text style={styles.th}>Migration Fee</Text>
          <Text style={styles.th}>Local Levy</Text>
          <Text style={styles.th}>Misc Fee</Text>
          <Text style={styles.th}>Re-Reg Fee</Text>
          <Text style={styles.th}>Total fees (Before start of late fee)</Text>
          <Text style={styles.th}>Late Fee</Text>
          <Text style={styles.th}>Total fees (After start of late fee)</Text>
        </View>

        {/* Table Body */}
        {tableData.length > 0 ? (
          tableData.map((item, index) => (
            <React.Fragment key={index}>
              {/* ===== DESCRIPTION ROW ===== */}
              {item.description ? (
                <View>
                  <Text style={styles.descriptionRow}>
                    Description: {item.description}
                  </Text>
                </View>
              ) : null}

              {/* ===== DATA ROW ===== */}
              <View style={styles.row} key={index}>
                <Text style={styles.tdIndex}>{index + 1}</Text>
                <Text style={styles.td}>{item.appearinG_TYPE || "—"}</Text>
                <Text style={styles.td}>
                  {item.castE_CATEGORY === "GENERAL"
                    ? "General & EWS"
                    : item.castE_CATEGORY === "OTHERS"
                    ? "SC/ ST/ BC-1/ BC-2"
                    : ""}
                </Text>
                <Text style={styles.td}>{item.registratioN_YEAR || ""}</Text>
                <Text style={styles.td}>
                  {item.category || "—"}{" "}
                  {item.category && (
                    <>
                      {"\n"}
                      <Text>
                        
                        {item.attempT_TYPE === "1"
                          ? "(First Attempt)"
                          : item.attempT_TYPE === "GREATER_THAN_1" ? "(Subsequent Attempt)" : ""}
                        
                      </Text>
                    </>
                  )}
                </Text>
                <Text style={styles.td}>{item.gender || ""}</Text>
                <Text style={styles.td}>{item.odppM_FEE || ""}</Text>
                <Text style={styles.td}>{item.exaM_FEE || ""}</Text>
                <Text style={styles.td}>{item.pC_FEE || ""}</Text>
                <Text style={styles.td}>{item.m_S_FEE_F_C_T || ""}</Text>
                <Text style={styles.td}>{item.miG_FEE || ""}</Text>
                <Text style={styles.td}>{item.locaL_LEVY || ""}</Text>
                <Text style={styles.td}>{item.misC_FEE || ""}</Text>
                <Text style={styles.td}>{item.rE_REG_FEE || ""}</Text>
                <Text style={styles.td}>
                  {item.beforE_LATE_TOTAL_FEE || ""}
                </Text>
                <Text style={styles.td}>{item.latE_FEE || ""}</Text>
                <Text style={styles.td}>{item.afteR_LATE_TOTAL_FEE || ""}</Text>
              </View>
            </React.Fragment>
          ))
        ) : (
          <View style={styles.row}>
            <Text style={{ ...styles.td, width: "100%", textAlign: "center" }}>
              No data available
            </Text>
          </View>
        )}
      </View>
    </Page>
  </Document>
);

export default FeesStructurePdf12;
